type BreakpointKey = keyof typeof Breakpoints;

export const Breakpoints = {
  XS: { min: 360, max: 639 },
  S: { min: 640, max: 979 },
  M: { min: 980, max: 1279 },
  L: { min: 1280, max: 1599 },
  XL: { min: 1600, max: Infinity },
} as const;

export class BreakpointUtils {
  private static get width(): number {
    return typeof window !== "undefined" ? window.innerWidth : 0;
  }

  static getCurrentBreakpoint(): BreakpointKey | undefined {
    return (Object.keys(Breakpoints) as BreakpointKey[])
      .find(bp => this.isInRange(bp));
  }

  static isInRange(bp: BreakpointKey): boolean {
    const { min, max } = Breakpoints[bp];
    return this.width >= min && this.width <= max;
  }

  static isAtLeast(bp: BreakpointKey): boolean {
    return this.width >= Breakpoints[bp].min;
  }

  static isAbove(bp: BreakpointKey): boolean {
    return this.width > Breakpoints[bp].min;
  }

  static isAtMost(bp: BreakpointKey): boolean {
    return this.width <= Breakpoints[bp].max;
  }

  static isBelow(bp: BreakpointKey): boolean {
    return this.width < Breakpoints[bp].max;
  }
}
